import {
  BuildingStorefrontIcon,
  CalendarIcon,
  ChartPieIcon,
  CircleStackIcon,
  Cog6ToothIcon,
  DocumentDuplicateIcon,
  FolderIcon,
  HomeIcon,
  LinkIcon,
  ServerStackIcon,
  UsersIcon,
} from '@heroicons/react/24/outline'
import { useTranslation } from '../../Translation';
import { useNavigate } from 'react-router-dom';
import { useAppState } from '../../Store';
import { PhoneIcon, UserGroupIcon } from '@heroicons/react/24/solid';




function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function SettingSidebarNav({currentPage}) {
  const { translate } = useTranslation();
  const navigate = useNavigate();
  const appState = useAppState();

  const userRole = appState.userRole;

  console.log(userRole);

  const isAdmin = userRole?.find(ur => ur.role === 'ROLE_ADMIN');

  const navigation = [
    { name: translate('setting.general.title'), href: '/settings', icon: HomeIcon, current: currentPage === 'general' },
    { name: translate('setting.customFields'), href: '/settings/custom-field', icon: CircleStackIcon, current: currentPage === 'customFields' },
    { name: translate('setting.globalVariable.title'), href: '/settings/global-variable', icon: ServerStackIcon, current: currentPage === 'globalVariable' },
    { name: translate('setting.integration'), href: '/settings/integration', icon: LinkIcon, current: currentPage === 'integration' },
    { name: translate('setting.shopify.title'), href: '/settings/shopify', icon: BuildingStorefrontIcon, current: currentPage === 'shopify' },
    { name: translate('setting.twilio.title'), href: '/settings/twilio', icon: PhoneIcon, current: currentPage === 'twilio' },
    { name: translate('setting.apps.title'), href: '/settings/apps', icon: LinkIcon, current: currentPage === 'apps' },
    { name: translate('setting.documentation.title'), href: '/settings/documentation', icon: DocumentDuplicateIcon, current: currentPage === 'documentation' },
    ...(isAdmin ? [{ name: translate('setting.admin.title'), href: '/settings/admin', icon: UserGroupIcon, current: currentPage === 'admin' }] : [])
  ]

  return (
    <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-gray-900 px-6 w-24 md:w-72 min-h-screen fixed top-16 h-full">
      <div className="flex h-16 shrink-0 items-center">
        <h3 className='text-white text-2xl font-bold hidden md:block'>{translate('settings')}</h3>
        <Cog6ToothIcon className='text-white size-6 md:hidden' />
      </div>
      <nav className="flex flex-1 flex-col">
        <ul role="list" className="flex flex-1 flex-col gap-y-7">
          <li>
            <ul role="list" className="-mx-2 space-y-1 flex flex-col">
              {navigation.map((item) => (
                <li key={item.name}>
                  <a
                    onClick={() => {
                      navigate(item.href);
                    }}
                    className={classNames(
                      item.current ? 'bg-gray-800 text-white' : 'text-gray-400 hover:bg-gray-800 hover:text-white',
                      'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold cursor-pointer w-12 md:w-full',
                    )}
                  >
                    <item.icon aria-hidden="true" className="size-6 shrink-0" />
                    <span className="hidden md:block">{item.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  )
}
